export default ({componentId, componentType, productId, productType}) => {
    const extensions = () => {
        return {componentId, componentType, productId, productType}
    }

    return {extensions}
}
